import React from 'react'
import styled from 'styled-components'

import Project from './Project'
import Banner from '../Banner'
const Projects = ({ projects, title }) => {
  return (
    <Wrapper>
      <section className="">
        <h3 className="posts-title">{title}</h3>
        <div>
          <article className="grid">
            {projects.map(project => {
              return <Project key={project.id} {...project} />
            })}
          </article>
        </div>
      </section>
    </Wrapper>
  )
}
const Wrapper = styled.div`
  padding: 0 24px;

  @media (min-width: 768px) {
    .grid {
      padding: 0 40px;
      width: 100%;
      max-width: 100vw;
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-gap: 20px;
    }
    .posts-title {
      margin-left: 40px;
    }
  }
  @media (min-width: 900px) {
    .grid {
      padding: 0 40px;
      width: 100%;
      max-width: 100vw;
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      grid-gap: 20px;
    }
  }
`

export default Projects
